// extracted by mini-css-extract-plugin
export default {"main":"styles_main__0BMiE","cartCells":"styles_cartCells__Qnxts","cartCell":"styles_cartCell__A9f1W"};